export const HelpSiteValidation = (formData) => {
    const errors = {};
    if (!formData.HelpSite) {
        errors.HelpSite = 'This field is required';
    }
    if (!formData.FormID === 0) {
        errors.FormID = 'This field is required';
    }
    if (!formData.ID === 0) {
        errors.ID = 'This field is required';
    }
    return errors;
};

